export enum CarpetView {
  TOP_CARPET,
  BOTTOM_CARPET
}
